// extracted by mini-css-extract-plugin
export default {"zoomModal":"Eea-z","image":"Fea-z","button":"Gea-z","isOverlayShown":"Hea-z"};